import React from 'react';
import { Typography, Divider, Box } from '@mui/material';

const TypeColorMap = {
  error: 'danger.clr-700',
  default: 'neutral.clr-600',
};

/**
 * @param {Array} props.items - An array of content items to display. Each item should be an object with the following properties:
 *   @param {string} props.items[].content - The text content to display.
 *   @param {string} [props.items[].type] - The type of the content, used to determine the text color.
 *   @param {boolean} [props.items[].hide] - If true, the item will be hidden.
 *
 */
const Footer = ({ items = [], ...props }) => {
  const visibleItems = items.filter(item => !item.hide);

  return (
    items.length ?
      <Box {...props}>
        {visibleItems.map((item, index) => (
          <React.Fragment key={index}>
            <Typography px={5} variant="body01-bold" color={TypeColorMap[item.type] || TypeColorMap.default}>
              {item.content}
            </Typography>
            {index !== visibleItems.length - 1 && <Divider sx={{ borderColor: '#CCD4DE' }} />}
          </React.Fragment>
        ))}
      </Box> : null
  );
};

export default Footer;
